import { render, staticRenderFns } from "./TaxIdNumber.vue?vue&type=template&id=b694ad6a&"
import script from "./TaxIdNumber.vue?vue&type=script&lang=js&"
export * from "./TaxIdNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports